import { formatIQD } from '../../../shared/format.js';

function normalize(data) {
  const arr = Array.isArray(data) ? data : data?.data || data?.items || [];
  return arr.slice(0, 10).map((r, i) => ({
    id: r.productId ?? r.id ?? r._id ?? `tp-${i}`,
    name: r.name ?? r.productName ?? '—',
    qty: Number(r.qty ?? r.quantity ?? r.sold ?? 0),
    revenue: Number(r.revenue ?? r.total ?? r.amount ?? 0),
    emoji: r.emoji || ''
  }));
}

export function TopProductsTable({ data }) {
  const rows = normalize(data);
  const max = rows.reduce((m, r) => Math.max(m, r.revenue), 0) || 1;

  if (!rows.length) {
    return <div className="text-ink-3 text-center py-10 text-sm">لا توجد بيانات بعد</div>;
  }

  return (
    <table className="w-full text-[13px]">
      <thead className="text-ink-2 text-[12px]">
        <tr className="border-b border-line">
          <th className="p-2.5 text-start">المنتج</th>
          <th className="p-2.5 text-start">الكمية</th>
          <th className="p-2.5 text-start">الإيراد</th>
          <th className="p-2.5 text-start">الحصة</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.id} className="border-b border-line">
            <td className="p-2.5">
              {r.emoji ? <span className="text-lg ms-1">{r.emoji}</span> : null}
              <span className="font-bold">{r.name}</span>
            </td>
            <td className="p-2.5 font-bold">{r.qty}</td>
            <td className="p-2.5 font-bold" style={{ color: '#C2570D' }}>
              {formatIQD(r.revenue)}
            </td>
            <td className="p-2.5">
              <div className="h-1.5 bg-paper-2 rounded-full relative" style={{ minWidth: 90 }}>
                <div
                  className="absolute inset-y-0 right-0 bg-orange rounded-full"
                  style={{ width: `${Math.round((r.revenue / max) * 100)}%` }}
                />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
